import React from 'react';
import PropTypes from 'prop-types';
import './PageLoader.css';

/**
 * Quiet loading state for a page or panel: a thin brand-green line plus soft placeholder blocks,
 * so moving between screens never looks like a full page reload.
 */
const PageLoader = ({ rows = 3, compact = false }) => (
  <div className={`page-loader${compact ? ' page-loader--compact' : ''}`} role="status" aria-live="polite">
    <span className="page-loader__bar" />
    <span className="visually-hidden">Loading</span>
    {!compact && (
      <div className="page-loader__blocks" aria-hidden="true">
        <span className="page-loader__block page-loader__block--title" />
        {Array.from({ length: rows }, (_, index) => <span key={index} className="page-loader__block" />)}
      </div>
    )}
  </div>
);

PageLoader.propTypes = { rows: PropTypes.number, compact: PropTypes.bool };

export default PageLoader;
